import { Theme, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React from 'react'
import Spinner, { SpinnerProps } from './Spinner'


const useStyles = makeStyles()(({ spacing, typography: { h6 } }: Theme) => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    message: {
        marginTop: spacing(2),
        fontSize: h6.fontSize,
        fontWeight: 300,
    },
}))

const Loading: React.FC<SpinnerProps & { message?: React.ReactNode; isLoadingBtn?: boolean }> = ({
    message,
    isLoadingBtn,
    ...props
}) => {
    const [size, setSize] = React.useState<number>(0)
    const { classes } = useStyles()
    const ref = React.useRef<any>()
    const innerWidth = typeof window !== 'undefined' ? window.innerWidth : 0
    React.useEffect(() => {
        if (ref.current) {
            const { clientHeight: height, clientWidth: width } = ref.current
            setSize(Math.min(height * 0.6, width * 0.6, 60))
        }
    }, [ref, innerWidth])
    return (
        <div ref={ref} className={classes.root}>
            <Spinner size={size} {...props} />
            {!isLoadingBtn ? (
                message ? (
                    <Typography className={classes.message}>{message}</Typography>
                ) : (
                    <Typography className={classes.message}>
                        Please wait for a moment...
                    </Typography>
                )
            ) : null}
        </div>
    )
}

Loading.defaultProps = {
    color: 'inherit',
    thickness: 2,
}

export default Loading
